import React from 'react';

import { ILink } from '../../../../../types/contentful';

import { FooterNavigationLink } from './Link';

interface NavListProps {
  links: ILink[];
}

export function NavList({ links }: NavListProps) {
  return (
    <ul className="m-0 flex list-none columns-1 flex-col gap-[.35rem] p-0 [&_li]:break-inside-avoid-column">
      {links &&
        links.map(({ fields }, idx) => (
          <FooterNavigationLink key={idx} {...fields} />
        ))}
    </ul>
  );
}
